export const researchAssistantSectionMessageEn = {
  'projects.cohortBuilderPage.researchAssistant.itemsToReview':
    'Items to review ({itemsToReviewCount})',
  'projects.cohortBuilderPage.researchAssistant.noItemsToReview': 'No changes to review',

  'projects.cohortBuilderPage.researchAssistant.updateInfoMessage':
    'You updated the cohort definition',
  'projects.cohortBuilderPage.researchAssistant.savedInfoMessage':
    'You saved the cohort definition',
  'projects.cohortBuilderPage.researchAssistant.processedInfoMessage':
    'You processed the cohort definition',
  'projects.cohortBuilderPage.researchAssistant.updateModelVersionInfoMessage':
    'Model version changed from {oldModelVersion} to {newModelVersion}',
};
